module.exports = __webpack_public_path__ + "media/images/crypto-currencies/bitcoincash-fa3e6362905a1ff17ca63db4cd05aff8.svg";